// All user-facing copy, per language. Keep both trees in the same shape.
const strings = {
  en: {
    nav: {
      primary: "Primary",
      work: "Work",
      skills: "Skills",
      experience: "Experience",
      about: "About",
      contact: "Contact",
      cv: "CV",
    },
    status: "Open to job opportunities",
    theme: {
      light: "Light",
      dark: "Dark",
      toLight: "Switch to light mode",
      toDark: "Switch to dark mode",
    },
    lang: {
      label: "Language",
    },
    hero: {
      titleBefore: "I turn ideas into ",
      titleAccent: "working",
      titleAfter: " products.",
      lead: "iOS and frontend developer. I work with SwiftUI on iOS, and React and TypeScript on the web.",
      hint: "The keyboard works as the menu. Press a key.",
      hintKey: "WORK",
      keyboard: "Keyboard navigation",
    },
    display: {
      idleCompact: "The keyboard works as the menu. Tap a key.",
      idle: ["Type something — or press ", " or the ", " bar."],
      allWork: "See all work ↓",
      cvHint: "Experience, projects, skills and education (PDF, in Turkish).",
      cvButton: "Download CV ↓",
      message: "Send a message →",
    },
    keys: {
      clear: "clear",
      clearAria: "Clear",
      del: "delete",
      delAria: "Delete",
      fnToLight: "light",
      fnToDark: "dark",
      work: "WORK",
      workAria: "Show work",
      skills: "SKILLS",
      skillsAria: "Show skills",
      cv: "CV",
      cvAria: "Show CV",
      contact: "CONTACT",
      contactSub: "F5 · write to me",
      contactAria: "Show contact",
    },
    work: {
      title: "Work",
      intro: "Projects I’ve built and released. Click a card to open it.",
      shotOf: "Screenshot of",
      visit: "Visit ↗",
      carousel: "Projects",
      projects: {
        flikk: {
          kind: "iOS app",
          desc: "Clean up your photo library by swiping to keep or delete. Built with SwiftUI, with widgets and 12 languages.",
        },
        deskwren: {
          kind: "Mac + iPhone app",
          desc: "Turns your iPhone into a remote for your Mac: launch apps, run Shortcuts, and control media and system settings with gestures.",
        },
        tadoy: {
          kind: "QR menu",
          desc: "A digital QR menu for Tadoy Café, with dynamic category management and a mobile-friendly interface.",
        },
      },
      moreMeta: "GitHub · all repositories",
      moreTitle: "More on GitHub ↗",
      talkMeta: "New project",
      talkTitle: "Have a project in mind? Let’s talk →",
    },
    skills: {
      title: "Skills",
      intro: "The technologies I work with. Click one for details.",
      items: [
        { name: "SwiftUI", cap: "iOS", note: "iOS and macOS interfaces, with WidgetKit and StoreKit 2." },
        { name: "Swift", cap: "iOS", note: "Native apps with Xcode, TestFlight and App Store Connect." },
        { name: "React", cap: "web", note: "Enterprise-scale interfaces with Redux and reusable components." },
        { name: "TypeScript", cap: "lang", note: "Three years of daily use on web projects." },
        { name: "JavaScript", cap: "lang", note: "ES6+, with Vite as the build tool." },
        { name: "HTML & CSS", cap: "style", note: "Responsive layouts, TailwindCSS and Material-UI." },
      ],
    },
    experience: {
      title: "Experience",
      intro: "Where I’ve worked and what I did there. Press a key to switch.",
      items: [
        {
          period: "Oct 2025 – Present",
          role: "Independent iOS Developer",
          company: "Flikk · Deskwren",
          points: [
            "Built Flikk from scratch with SwiftUI and released it on the App Store, with widgets and support for 12 languages.",
            "Set up subscriptions with StoreKit 2 and ads with AdMob, and ran Apple Search Ads campaigns.",
            "Developed the iOS and macOS apps for Deskwren, which turns an iPhone into a remote for a Mac.",
          ],
        },
        {
          period: "Oct 2022 – Oct 2025",
          role: "Software Developer (Frontend)",
          company: "IC Holding",
          points: [
            "Built enterprise-scale user interfaces with React, Redux and TypeScript.",
            "Took internal web projects from requirements analysis to production.",
            "Defined data flows and integration rules for Django REST APIs together with the backend team.",
            "Set up reusable component structures and the multi-language (i18n) infrastructure.",
          ],
        },
        {
          period: "Internship",
          role: "iOS Developer Intern",
          company: "Kafein Technology Solutions",
          points: ["Worked on interfaces and core app flows of mobile apps in Swift."],
        },
        {
          period: "Internship",
          role: "Frontend Developer Intern",
          company: "Hub Studio",
          points: ["Built responsive web interfaces and user experience improvements."],
        },
      ],
    },
    about: {
      title: "About",
      lead: "I’m a computer engineer who builds apps for iOS and the web.",
      body: "I graduated in Computer Engineering from Trakya University in 2022. I enjoy working on every stage of a product, from understanding what users need to building the interface and releasing it. Because I act as the product owner on my own apps, I’m comfortable bridging business units and software teams.",
      label: {
        role: "DEVELOPER",
        model: "Model",
        layout: "Layout",
        layoutValue: "iOS + Frontend",
        switches: "Switches",
        since: "In service since",
        status: "Status",
        statusValue: "Open to work",
        serial: "S/N 0000-OPEN-TO-WORK",
      },
    },
    contact: {
      title: "Press enter to say hi.",
      intro: "Have a role or a project in mind? Write below — it lands straight in my inbox.",
      name: "Name",
      email: "Email",
      message: "Message",
      hint: "Ctrl + Enter sends from the message box.",
      enter: "ENTER",
      sending: "SENDING…",
      sent: "SENT ✓",
      retry: "TRY AGAIN",
      sendAria: "Send message",
      success: "Thanks, your message was sent. I’ll get back to you soon.",
      error: "Something went wrong. Please try again, or reach me on LinkedIn.",
    },
    critter: {
      hello: "hi! I’m Cap. I live here",
      returning: ["you again? welcome back!", "oh, a familiar face", "I knew you’d come back"],
      poke: ["hey!", "that tickles!", "boop yourself", "do that again", "what did I do?"],
      dizzy: "okay okay, I surrender!",
      wake: ["I wasn’t sleeping, just resting my eyes", "huh? what year is it?"],
      dark: "who turned off the lights?",
      light: "ow, my eyes",
      sections: {
        work: "Mert built these. I supervised",
        skills: "go on, press one. what could go wrong",
        experience: "he worked hard, I’m a witness",
        about: "good kid, I vouch for him",
        contact: "write to him, he doesn’t bite",
      },
      grab: ["put me down, I have no money!", "mooom!", "I’m scared of heights!"],
      thrown: ["wheeee!", "don’t tell Mert!", "I’m flying!"],
      landed: ["again! again!", "I feel a bit sick", "nailed the landing"],
      slip: ["missed the letter!", "that one’s slippery!", "whoa whoa whoa"],
      ouch: ["I fell… nobody saw that, right?", "I’m fine. my pride isn’t", "gravity 1, Cap 0"],
      trip: ["tripped!", "tripped over a pixel"],
      tripUp: ["you didn’t see that", "I meant to do that"],
      leaving: ["be right back!", "one second, I left the kettle on", "hold on, got a thing"],
      hiding: ["I’m hiding. don’t tell", "you never saw me"],
      peek: ["peekaboo!", "here I am!"],
      dropIn: ["found a shortcut from above", "my parachute didn’t open", "it was raining keys"],
      chute: ["it opened this time!", "soft landing, ten out of ten"],
      carLeave: ["my ride’s here, bye!", "step on it!"],
      carBack: ["couldn’t find parking, sorry I’m late", "ran out of petrol, so I’m back"],
      back: [
        "I’m back! went to check on the other projects",
        "did you miss me?",
        "back! did I miss anything?",
        "dropped by Flikk, it says hi",
      ],
      musings: [
        "nice weather for coding",
        "should I get a coffee? I don’t have a mouth for it",
        "rent is free on this site",
        "don’t tell Mert, but I’m the best key",
        "I thought I saw a bug… no, just dust",
        "nobody ever commits me",
        "I’m not a 404, I’m right here",
        "if I had a shift key I’d be taller",
        "I wonder what’s outside the viewport",
        "still here? me too",
      ],
      exercise: ["workout time!", "one… two… three… that’s enough"],
      hum: "la la la ♪",
      sneeze: "achoo!",
      stare: ["are you looking at me?", "what, never seen a key before?"],
      hopscotch: "hopscotch!",
      clock: "it’s {t} already",
      night: "what are you doing up at this hour? go to sleep",
      long: "you’ve been here two minutes. just hire him",
      away: ["where did you go? I got bored", "oh, welcome back"],
      copy: "you copied that. I saw",
      menu: "peeking at my source code? rude",
      resize: ["the house got smaller!", "ah, roomy"],
      yawn: "getting sleepy…",
      fast: "slow down, I’m getting dizzy",
      bottom: "that’s the end. write to him already",
      sent: "it’s gone! hooray",
      // Said while it plays with the labels in the Flikk screenshot
      later: ["I’ll decide on this one later", "this one… I’ll think about it"],
      // In the Deskwren screenshot, after jumping on the closed laptop
      lid: ["the lid won’t open. fine, I’ll use the remote", "ugh, it’s stuck. good thing I have a remote"],
      // The guided tour it offers: one line (or two) per stop
      tour: {
        offer: "hi! want me to show you around? it takes a minute",
        yes: "show me",
        no: "later",
        next: "next",
        stop: "end tour",
        later: "sure! if you change your mind, click me twice",
        start: "great! follow me",
        hero: "this is Mert’s site. he’s an iOS and frontend developer",
        hero2: "this keyboard is the menu. but relax, I’ll take you",
        work: "these are things he built and released",
        flikk: "Flikk: you clean up your photo library by swiping. it’s on the App Store",
        deskwren: "Deskwren turns an iPhone into a remote for the Mac. it’s in App Store review",
        tadoy: "and this is the QR menu of Tadoy Café. so he does web too",
        skills: "his daily tools: SwiftUI and Swift on iOS",
        skills2: "and React and TypeScript on the web. three years, every day",
        xp1: "he spent three years at IC Holding building enterprise web interfaces",
        xp0: "since October 2025 he’s been building and releasing his own iOS apps",
        about: "a computer engineer. he writes the code and works out what to build",
        contact: "liked what you saw? write to him here. the CV is up top",
        end: "that’s the tour! I’ll be around. poke me if you get bored",
        stopped: "okay, we’ll stop here. I’ll be around",
      },
      // Typed on the hero keyboard (it only has the letters of MERT KERIMI)
      typed: { MERT: "that’s my boss", TREK: "beam me up", ME: "no, me!" },
      // What it says about the thing the pointer is resting on (data-critter)
      about: {
        flikk: ["swipe right to keep, left to delete. like this!", "my gallery has never been this clean", "it’s on the App Store, go get it"],
        deskwren: ["watch: I turn the Mac up from my phone", "volume down without leaving the couch", "in App Store review. fingers crossed"],
        tadoy: ["look, I got ice cream! want some?", "scan the QR, pick a dessert", "one more scoop wouldn’t hurt"],
        github: ["all the code lives there. mine too"],
        talk: ["come on, let’s build something"],
        "skill-0": ["Flikk is written in this", "the widgets too"],
        "skill-1": ["the mother tongue of iOS"],
        "skill-2": ["I’m drawn with React myself!", "three years of enterprise UI"],
        "skill-3": ["no type errors on his watch"],
        "skill-4": ["where it all started"],
        "skill-5": ["my legs swing thanks to CSS, look"],
        "xp-0": ["building his own apps now", "Flikk was born here"],
        "xp-1": ["three years of React and TypeScript", "the suit-and-tie years"],
        "xp-2": ["first steps in iOS"],
        "xp-3": ["first steps in frontend"],
        label: ["lifetime warranty", "the serial number is top secret"],
        name: ["what’s your name? I’m Cap"],
        email: ["no spam, promise"],
        message: ["I won’t read it. okay, maybe a little", "take your time"],
        enter: ["press it press it press it!", "hit enter and off it goes"],
        cv: ["two pages, quick read", "download it, you won’t regret it"],
        lang: ["I speak two languages, you know"],
        theme: ["you control the lights"],
        status: ["yes, he’s looking for a job! hire him"],
        brand: ["that’s the boss’s name"],
        title: ["my favourite sentence"],
        socials: ["follow him, he’ll like that"],
        top: ["going up? wait for me"],
      },
    },
    footer: {
      copy: "Mert Kerimi · design and development",
      top: "back to top ↑",
    },
  },

  tr: {
    nav: {
      primary: "Ana menü",
      work: "İşler",
      skills: "Yetenekler",
      experience: "Deneyim",
      about: "Hakkımda",
      contact: "İletişim",
      cv: "CV",
    },
    status: "İş fırsatlarına açığım",
    theme: {
      light: "Açık",
      dark: "Koyu",
      toLight: "Açık moda geç",
      toDark: "Koyu moda geç",
    },
    lang: {
      label: "Dil",
    },
    hero: {
      titleBefore: "Fikirleri ",
      titleAccent: "çalışan",
      titleAfter: " ürünlere çeviririm.",
      lead: "iOS ve frontend geliştiriciyim. iOS’ta SwiftUI, webde React ve TypeScript kullanıyorum.",
      hint: "Klavye menü olarak çalışıyor. Bir tuşa bas.",
      hintKey: "İŞLER",
      keyboard: "Klavye menüsü",
    },
    display: {
      idleCompact: "Klavye menü olarak çalışıyor. Bir tuşa dokun.",
      idle: ["Bir şey yaz — ya da ", " veya ", " tuşuna bas."],
      allWork: "Tüm işler ↓",
      cvHint: "Deneyim, projeler, yetenekler ve eğitim (PDF).",
      cvButton: "CV indir ↓",
      message: "Mesaj gönder →",
    },
    keys: {
      clear: "temizle",
      clearAria: "Temizle",
      del: "sil",
      delAria: "Sil",
      fnToLight: "açık",
      fnToDark: "koyu",
      work: "İŞLER",
      workAria: "İşleri göster",
      skills: "YETENEKLER",
      skillsAria: "Yetenekleri göster",
      cv: "CV",
      cvAria: "CV’yi göster",
      contact: "İLETİŞİM",
      contactSub: "F5 · bana yaz",
      contactAria: "İletişimi göster",
    },
    work: {
      title: "İşler",
      intro: "Geliştirip yayınladığım projeler. Açmak için karta tıkla.",
      shotOf: "Ekran görüntüsü:",
      visit: "Ziyaret et ↗",
      carousel: "Projeler",
      projects: {
        flikk: {
          kind: "iOS uygulaması",
          desc: "Fotoğrafları kaydırarak tutup silerek galerini temizlersin. SwiftUI ile geliştirildi; widget ve 12 dil desteği var.",
        },
        deskwren: {
          kind: "Mac + iPhone uygulaması",
          desc: "iPhone’unu Mac’inin kumandasına çevirir: uygulama aç, Kestirmeler çalıştır, medya ve sistem ayarlarını hareketlerle kontrol et.",
        },
        tadoy: {
          kind: "QR menü",
          desc: "Tadoy Café için dijital QR menü. Dinamik kategori yönetimi ve mobil uyumlu arayüz.",
        },
      },
      moreMeta: "GitHub · tüm repolar",
      moreTitle: "Daha fazlası GitHub’da ↗",
      talkMeta: "Yeni proje",
      talkTitle: "Aklında bir proje mi var? Konuşalım →",
    },
    skills: {
      title: "Yetenekler",
      intro: "Kullandığım teknolojiler. Detay için birine tıkla.",
      items: [
        { name: "SwiftUI", cap: "iOS", note: "iOS ve macOS arayüzleri; WidgetKit ve StoreKit 2." },
        { name: "Swift", cap: "iOS", note: "Xcode, TestFlight ve App Store Connect ile native uygulamalar." },
        { name: "React", cap: "web", note: "Redux ve yeniden kullanılabilir component’lerle kurumsal arayüzler." },
        { name: "TypeScript", cap: "dil", note: "Web projelerinde 3 yıl günlük kullanım." },
        { name: "JavaScript", cap: "dil", note: "ES6+, derleme aracı olarak Vite." },
        { name: "HTML & CSS", cap: "stil", note: "Responsive arayüzler, TailwindCSS ve Material-UI." },
      ],
    },
    experience: {
      title: "Deneyim",
      intro: "Çalıştığım yerler ve orada yaptıklarım. Geçmek için bir tuşa bas.",
      items: [
        {
          period: "Eki 2025 – Günümüz",
          role: "Bağımsız iOS Geliştirici",
          company: "Flikk · Deskwren",
          points: [
            "Flikk’i SwiftUI ile sıfırdan geliştirip App Store’da yayına aldım; widget ve 12 dil desteği ekledim.",
            "StoreKit 2 ile abonelik sistemini, AdMob ile reklam altyapısını kurdum; Apple Search Ads kampanyalarını yönettim.",
            "iPhone’u Mac için kumandaya dönüştüren Deskwren’in iOS ve macOS uygulamalarını geliştirdim.",
          ],
        },
        {
          period: "Eki 2022 – Eki 2025",
          role: "Yazılım Geliştirici (Frontend)",
          company: "IC Holding",
          points: [
            "React, Redux ve TypeScript ile kurumsal ölçekli kullanıcı arayüzleri geliştirdim.",
            "Şirket içi web projelerini gereksinim analizinden canlıya kadar yürüttüm.",
            "Backend ekibiyle Django REST API’lerinin veri akışlarını ve entegrasyon kurallarını tanımladım.",
            "Yeniden kullanılabilir component yapılarını ve çoklu dil (i18n) altyapısını kurdum.",
          ],
        },
        {
          period: "Staj",
          role: "iOS Geliştirici Stajyeri",
          company: "Kafein Technology Solutions",
          points: ["Swift ile mobil uygulamaların arayüzleri ve temel akışları üzerinde çalıştım."],
        },
        {
          period: "Staj",
          role: "Frontend Geliştirici Stajyeri",
          company: "Hub Studio",
          points: ["Responsive web arayüzleri ve kullanıcı deneyimi iyileştirmeleri geliştirdim."],
        },
      ],
    },
    about: {
      title: "Hakkımda",
      lead: "Bilgisayar mühendisiyim; iOS ve web için uygulamalar geliştiriyorum.",
      body: "Trakya Üniversitesi Bilgisayar Mühendisliği’nden 2022’de mezun oldum. Kullanıcının ihtiyacını anlamaktan arayüzü kodlamaya ve yayına almaya kadar bir ürünün her aşamasında çalışmayı seviyorum. Kendi uygulamalarımda ürün sahibi rolünü de üstlendiğim için iş birimleriyle yazılım ekipleri arasında köprü kurabiliyorum.",
      label: {
        role: "GELİŞTİRİCİ",
        model: "Model",
        layout: "Düzen",
        layoutValue: "iOS + Frontend",
        switches: "Switch’ler",
        since: "Hizmete giriş",
        status: "Durum",
        statusValue: "İşe açık",
        serial: "S/N 0000-İŞE-AÇIK",
      },
    },
    contact: {
      title: "Merhaba demek için enter’a bas.",
      intro: "Aklında bir pozisyon ya da proje mi var? Aşağıya yaz — doğrudan gelen kutuma düşer.",
      name: "Adın",
      email: "E-posta",
      message: "Mesajın",
      hint: "Mesaj kutusundayken Ctrl + Enter ile gönderebilirsin.",
      enter: "ENTER",
      sending: "GÖNDERİLİYOR…",
      sent: "GÖNDERİLDİ ✓",
      retry: "TEKRAR DENE",
      sendAria: "Mesajı gönder",
      success: "Teşekkürler, mesajın gönderildi. En kısa sürede dönüş yapacağım.",
      error: "Bir şeyler ters gitti. Tekrar dene ya da bana LinkedIn’den ulaş.",
    },
    critter: {
      hello: "selam! ben Tuş. burada yaşıyorum",
      returning: ["yine mi sen? hoş geldin!", "oo, tanıdık bir yüz", "geleceğini biliyordum"],
      poke: ["hey!", "gıdıklanıyorum yaa", "dürtme!", "bir daha yap", "ne yaptım ben şimdi?"],
      dizzy: "tamam tamam, teslim oluyorum!",
      wake: ["uyumuyordum, gözlerimi dinlendiriyordum", "hı? saat kaç oldu?"],
      dark: "ışıkları kim kapattı?",
      light: "ayy gözüm",
      sections: {
        work: "bunları Mert yaptı, ben izledim",
        skills: "bas bakalım, bir şey olmaz (herhalde)",
        experience: "çok çalıştı, ben şahidim",
        about: "iyi çocuktur, kefilim",
        contact: "yaz yaz, çekinme, ısırmaz",
      },
      grab: ["bırak beni, param yok!", "anneee!", "yükseklik korkum var!"],
      thrown: ["vuuuu!", "Mert görmesin!", "uçuyoruum!"],
      landed: ["bir daha! bir daha!", "midem bulandı biraz", "inişi gördün mü?"],
      slip: ["harfe basamadım!", "ayağım kaydı!", "bu harf kaygan!"],
      ouch: ["düştüm… kimse görmedi değil mi?", "bir şeyim yok. gururum hariç", "yerçekimi 1, Tuş 0"],
      trip: ["ayağım takıldı!", "piksele takıldım"],
      tripUp: ["görmedin değil mi?", "bilerek yaptım"],
      leaving: ["hemen geliyorum!", "bir saniye, ocakta çay var", "dur, bir işim var"],
      hiding: ["saklanıyorum, kimseye söyleme", "beni görmedin"],
      peek: ["cee!", "buradayım!"],
      dropIn: ["yukarıdan kestirme varmış", "paraşütüm açılmadı", "tuş yağıyordu"],
      chute: ["bu sefer açıldı!", "yumuşak iniş, on üzerinden on"],
      carLeave: ["arabam geldi, ben kaçtım!", "bas gaza!"],
      carBack: ["park yeri bulamadım, o yüzden geciktim", "benzin bitti, geri döndüm"],
      back: [
        "geldim geldim! diğer projelere bakmaya gitmiştim",
        "beni özledin mi?",
        "döndüm! bir şey kaçırmadım değil mi?",
        "Flikk’e uğradım, selamı var",
      ],
      musings: [
        "bugün hava tam kodlamalık",
        "kahve içsem mi? ağzım yok gerçi",
        "bu sitede kira yok, çok rahatım",
        "Mert’e söyleme ama en güzel tuş benim",
        "bir bug gördüm sanki… yok yok, tozmuş",
        "kimse beni commit’lemiyor",
        "404 değilim, buradayım",
        "shift’im olsa daha uzun olurdum",
        "ekranın dışında ne var acaba",
        "hâlâ burada mısın? ben de",
      ],
      exercise: ["spor zamanı!", "bir… iki… üç… yeter bu kadar"],
      hum: "la la la ♪",
      sneeze: "hapşuu!",
      stare: ["bana mı bakıyorsun?", "ne var, tuş görmedin mi?"],
      hopscotch: "seksek!",
      clock: "saat {t} olmuş bile",
      night: "bu saatte ne işin var? uyusana",
      long: "2 dakikadır buradasın, işe alsana artık",
      away: ["nereye gittin? sıkıldım", "oo, tekrar hoş geldin"],
      copy: "kopyaladın, gördüm!",
      menu: "kaynak koduma mı bakacaksın? ayıp",
      resize: ["ev küçüldü!", "oh, ferahladı"],
      yawn: "uykum geldi…",
      fast: "yavaş, başım dönüyor",
      bottom: "sona geldin. yazsana artık",
      sent: "gitti! yaşasın",
      later: ["buna sonra karar veririm", "bu… bir düşüneyim"],
      lid: ["kapak açılmıyor. neyse, kumandam var", "ıh! sıkışmış. iyi ki kumandam yanımda"],
      tour: {
        offer: "selam! istersen sana buraları gezdireyim, bir dakika sürer",
        yes: "gezdir",
        no: "sonra",
        next: "ileri",
        stop: "turu bitir",
        later: "tamam! fikrin değişirse bana iki kere tıkla",
        start: "süper! peşimden gel",
        hero: "burası Mert’in sitesi. kendisi iOS ve frontend geliştirici",
        hero2: "bu klavye de menü. ama sen yorulma, ben götürürüm",
        work: "bunlar yapıp yayınladığı işler",
        flikk: "Flikk: galerindeki fotoğrafları kaydırarak temizliyorsun. App Store’da yayında",
        deskwren: "Deskwren iPhone’u Mac’in kumandasına çeviriyor. App Store incelemesinde",
        tadoy: "bu da Tadoy Café’nin QR menüsü. yani web işi de yapıyor",
        skills: "her gün kullandıkları: iOS’ta SwiftUI ve Swift",
        skills2: "webde de React ve TypeScript. 3 yıl, her gün",
        xp1: "3 yıl IC Holding’de kurumsal web arayüzleri geliştirdi",
        xp0: "Ekim 2025’ten beri de kendi iOS uygulamalarını yapıp yayınlıyor",
        about: "bilgisayar mühendisi. hem kodu yazar hem ne yapılacağını çözer",
        contact: "beğendiysen buradan yaz, hızlı döner. CV de yukarıda",
        end: "tur bitti! ben buralardayım, canın sıkılırsa dürt",
        stopped: "tamam, burada keselim. ben buralardayım",
      },
      typed: { MERT: "o benim patron", KIM: "ben Tuş!", TIK: "tık tık!" },
      about: {
        flikk: ["sağa kaydır kalsın, sola kaydır sil. bak böyle!", "galerim hiç bu kadar temiz olmamıştı", "App Store’da, indir bence"],
        deskwren: ["bak, telefondan Mac’in sesini açıyorum", "koltuktan kalkmadan ses kısılır", "App Store incelemesinde. dua edin"],
        tadoy: ["bak dondurma aldım! sen de ister misin?", "QR’ı okut, tatlını seç", "bir top daha alsam mı"],
        github: ["kodların hepsi orada. benimki de"],
        talk: ["hadi, bir şey yapalım"],
        "skill-0": ["Flikk bununla yazıldı", "widget’lar da buradan"],
        "skill-1": ["iOS’un ana dili"],
        "skill-2": ["ben de React ile çizildim!", "3 yıl kurumsal arayüz"],
        "skill-3": ["tip hatasına geçit yok"],
        "skill-4": ["her şeyin başladığı yer"],
        "skill-5": ["bacaklarım CSS ile sallanıyor, bak"],
        "xp-0": ["artık kendi uygulamalarını yapıyor", "Flikk burada doğdu"],
        "xp-1": ["3 yıl React ve TypeScript", "takım elbiseli yıllar"],
        "xp-2": ["iOS’a ilk adım"],
        "xp-3": ["frontend’e ilk adım"],
        label: ["garantisi ömür boyu", "seri numarası çok gizli"],
        name: ["adın ne? ben Tuş"],
        email: ["spam yok, söz"],
        message: ["ben okumam. tamam, belki biraz", "acele etme, uzun yaz"],
        enter: ["bas bas bas!", "enter’a bas, gitsin"],
        cv: ["2 sayfa, hızlı okunur", "indir, pişman olmazsın"],
        lang: ["ben iki dil biliyorum, haberin olsun"],
        theme: ["ışıklar senin elinde"],
        status: ["evet, iş arıyor! işe alın"],
        brand: ["patronun adı"],
        title: ["en sevdiğim cümle"],
        socials: ["takip et, sevinir"],
        top: ["yukarı mı? beni de bekle"],
      },
    },
    footer: {
      copy: "Mert Kerimi · tasarım ve geliştirme",
      top: "başa dön ↑",
    },
  },
};

export const LANGS = ["en", "tr"];

export default strings;
